import {
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch
} from "@mui/material";
import { FastField, FieldArray } from "formik";
import {
  MyButton,
  MyMultiSelect,
  MySelect,
  MySelectTime,
  MySelectDateTime,
  MyTextField,
  MyTextFieldArea,
  UploadAnhDaiDien,
} from "../Lib/componentLibrarys";
import { AddCircleOutline, Check, Close } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import Api from "../../api2";

const currentYear = new Date().getFullYear();

const years = Array.from({ length: 5 }, (_, i) => ({ nam: currentYear - i }));

export const FormThongTinLichSu = ({
  view,
  values,
  errors,
  setFieldValue,
  trangThaiThongTinList
}) => {
  const [thongTinSanXuatList, setThongTinSanXuatList] = useState(null)
  const [coSoSanXuatList, setCoSoSanXuatList] = useState(null)
  const getApiThongTinLichSuSanXuat = (listIdCoSoSanXuat) => {
    new Api().GetListThongTinLichSuSanXuatOfThongTinCheBien(listIdCoSoSanXuat).then(data => {
      if (data.code === 200) {
        setThongTinSanXuatList(data?.data);
        const listDataThongTinSX = data?.data
        if (isEmpty(listDataThongTinSX)) {
          setFieldValue('thongTinSanXuats', null)
        } else if (!isEmpty(values?.thongTinSanXuats)) {
          const validIds = new Set(listDataThongTinSX?.map(item => item?.id));
          const dataThongTinSxHandle = values?.thongTinSanXuats?.filter(item => validIds.has(item?.id));
          setFieldValue('thongTinSanXuats', dataThongTinSxHandle)
        }
      }
    });
  }
  const getApiThongTinCoSo = (listIdNam) => {
    new Api().GetListCoSoSanXuatOfLichSuCheBien(listIdNam).then(data => {
      if (data.code === 200) {
        setCoSoSanXuatList(data?.data);
        const listDataThongTinCoSo = data?.data
        if (isEmpty(listDataThongTinCoSo)) {
          setFieldValue('coSoSanXuats', null)
        } else if (!isEmpty(values?.coSoSanXuats)) {
          const validIds = new Set(listDataThongTinCoSo?.map(item => item?.id));
          const dataThongTinSxHandle = values?.coSoSanXuats?.filter(item => validIds.has(item?.id));
          setFieldValue('coSoSanXuats', dataThongTinSxHandle)
        }
      }
    });
  }
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={12}>
          <FastField name="tenThongTinCheBien">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Tên thông tin chế biến:"
                placeholder="Nhập..."
                errors={errors?.tenThongTinCheBien}
                helperText={errors?.tenThongTinCheBien}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Năm sản xuất:"
            placeholder="Chọn..."
            isOptionEqualToValue={(option, value) => (
              option?.nam === value?.nam
            )}
            onChange={(option, value) => {
              setFieldValue(`namSanXuats`, value);
                const handleValueId = value?.map(x => x?.nam)
                if(!isEmpty(handleValueId)) {
                  getApiThongTinCoSo(handleValueId)
                } else {
                  setCoSoSanXuatList([])
                  setFieldValue('coSoSanXuats', null)
                }
            }}
            value={values?.namSanXuats || []}
            options={years || []}
            name="nam"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Cơ sở sản xuất:"
            placeholder="Chọn..."
            isOptionEqualToValue={(option, value) => (
              option?.id === value?.id
            )}
            onChange={(option, value) => {
              setFieldValue(`coSoSanXuats`, value);
              const handleValueId = value?.map(x => x?.id)
              if(!isEmpty(handleValueId)) {
                getApiThongTinLichSuSanXuat(handleValueId)
              } else {
                setThongTinSanXuatList([])
                setFieldValue('thongTinSanXuats', null)
              }
            }}
            value={values?.coSoSanXuats || []}
            options={coSoSanXuatList || []}
            name="tenCoSoSanXuat"
          />
        </Grid>

        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Thông tin sản xuất:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`thongTinSanXuats`, value);
            }}
            isOptionEqualToValue={(option, value) => (
              option?.id === value?.id
            )}
            value={values?.thongTinSanXuats || []}
            options={thongTinSanXuatList || []}
            name="tenThongTinSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Trạng thái thông tin:"
            placeholder="Chọn..."
            value={values?.trangThaiTT}
            options={trangThaiThongTinList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`trangThaiTT`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
                disabled={view}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormLichSuCheBien = ({
  view,
  values,
  errors,
  setFieldValue,
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="cheBiens"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.cheBiens?.length > 0 &&
                  values?.cheBiens?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Thông tin chế biến {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => !view && setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`cheBiens.[${index}].tenCongDoanCheBien`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Tên công đoạn chế biến:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectDateTime
                            disabled={view}
                            label="Thời gian bắt đầu"
                            placeholder="Chọn..."
                            value={values?.cheBiens?.[index]?.thoiGianBatDau}
                            onChange={(value) => {
                              setFieldValue(`cheBiens.[${index}].thoiGianBatDau`, value);
                            }}
                            width="100%"
                            style={{ height: '100px' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectDateTime
                            disabled={view}
                            label="Thời gian kết thúc"
                            placeholder="Chọn..."
                            value={values?.cheBiens?.[index]?.thoiGianKetThuc}
                            onChange={(value) => {
                              setFieldValue(`cheBiens.[${index}].thoiGianKetThuc`, value);
                            }}
                            width="100%"
                            style={{ height: '100px' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`cheBiens.[${index}].nguoiThucHien`}>
                            {({ field }) => (
                              <MyTextField
                                label="Người thực hiện:"
                                placeholder="Nhập..."
                                {...field}
                                disabled={view}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`cheBiens.[${index}].diaDiemCheBien`}>
                            {({ field }) => (
                              <MyTextField
                                label="Địa điểm chế biến:"
                                placeholder="Nhập..."
                                {...field}
                                disabled={view}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`cheBiens.[${index}].thongSoKyThuat`}>
                            {({ field }) => (
                              <MyTextField
                                label="Thông số kỹ thuật:"
                                placeholder="Nhập..."
                                {...field}
                                disabled={view}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`cheBiens.[${index}].ghiChu`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                disabled={view}
                                label="Ghi chú:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12} className="fileGiayChungNhan" style={{}}>
                          <UploadAnhDaiDien
                            disabled={view}
                            multi={false}
                            title="Hình ảnh:"
                            titleBtnUpload="Tải lên ảnh"
                            file={values?.cheBiens?.[index]?.hinhAnhs || []}
                            handleChangeFile={ values =>
                              setFieldValue(`cheBiens.[${index}].hinhAnhs`, values)
                            }
                            checkSave={false}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {values?.cheBiens?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin chế biến này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    !view &&
                    arrayHelpers.push({
                      tenCongDoanCheBien: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm thông tin chế biến</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export const FormLichSuMuaHang = ({
  view,
  values,
  errors,
  setFieldValue,
  trangThaiMuaList,
  coSoSanXuatList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="muaHangs"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.muaHangs?.length > 0 &&
                  values?.muaHangs?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Thông tin mua hàng {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => !view && setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`muaHangs.[${index}].maPhieuMua`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Mã phiếu mua:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`muaHangs.[${index}].tenHangHoa`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Tên hàng hóa:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            disabled={view}
                            label="Ngày mua:"
                            placeholder="Chọn..."
                            value={values?.muaHangs?.[index]?.ngayMua}
                            onChange={value => {
                              setFieldValue(
                                `muaHangs.[${index}].ngayMua`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelect
                            disabled={view}
                            label="Cơ sở sản xuất:"
                            placeholder="Chọn..."
                            value={values?.muaHangs?.[index]?.coSoSanXuat}
                            options={coSoSanXuatList || []}
                            name="tenCoSoSanXuat"
                            onChange={(event, value) => {
                              setFieldValue(
                                `muaHangs.[${index}].coSoSanXuat`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`muaHangs.[${index}].tenCoSoKhac`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Tên cơ sở khác:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`muaHangs.[${index}].soLuong`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Số lượng:"
                                placeholder="Nhập..."
                                type="number"
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`muaHangs.[${index}].nguoiMua`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Người mua:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelect
                            disabled={view}
                            label="Trạng thái mua:"
                            placeholder="Chọn..."
                            value={values?.muaHangs?.[index]?.trangThaiMuaHang}
                            options={trangThaiMuaList || []}
                            name="ten"
                            onChange={(event, value) => {
                              setFieldValue(
                                `muaHangs.[${index}].trangThaiMuaHang`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`muaHangs.[${index}].ghiChu`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                disabled={view}
                                label="Ghi chú:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12} className="fileGiayChungNhan" style={{}}>
                          <UploadAnhDaiDien
                            disabled={view}
                            multi={false}
                            title="Hình ảnh:"
                            titleBtnUpload="Tải lên ảnh"
                            file={values?.muaHangs?.[index]?.hinhAnhs || []}
                            handleChangeFile={ values =>
                              setFieldValue(`muaHangs.[${index}].hinhAnhs`, values)
                            }
                            checkSave={false}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {values?.muaHangs?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin mua hàng này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    !view && arrayHelpers.push({
                      maPhieuMua: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm thông tin mua hàng</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};
